import { ref as e } from "vue";
const r = e(null), t = e(null);
export {
  r as draggingItem,
  t as hoveredItem
};
